import React from 'react';
import { Routes, Route } from 'react-router-dom';
import CMSC from './components/admin/CMS';

function App() {
  return (
    <Routes>
      {/* CMS */}
      <Route path="/*" element={<CMSC />} />
      {/* CMS */}
    </Routes>
  );
}
export default App;